<template>
  <div class="overlay">
    <PProgressCircular class="loader" indeterminate />
    <h4 class="text">Sistema em atualização. Aguarde.</h4>
  </div>
</template>

<script>
import { PProgressCircular } from 'pioneira-ui';

export default {
  components: {
    PProgressCircular,
  },
};
</script>

<style lang="scss" scoped>
.overlay {
  z-index: 999;
  opacity: 0.85;
  position: absolute;
  background: white;
  left: 0;
  top: -30px;
  width: 100%;
  height: calc(100% + 30px);
  text-align: center;
}

.loader {
  margin-left: auto;
  margin-top: 45vh;
}

.text {
  margin-top: 12px;
  color: var(--v-primary_sicredi-base);
}
</style>
